import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import ProjectWizard from "./pages/ProjectWizard";
import AdminDashboard from "./pages/AdminDashboard";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Verify from "./pages/Verify";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Home from "./pages/Home";
import SingleUnitSelection from "./pages/SingleUnitSelection";
import { AuthProvider, useAuth } from "./lib/auth";
import { Navigate } from "react-router-dom";
import SessionExpiredModal from "./components/SessionExpiredModal";
import "@/App.css";

// Root route: signed-in users land on the new home page (Projects vs Single
// Unit cards), guests on the login page.
function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) return null;
  return <Navigate to={user ? "/home" : "/login"} replace />;
}

function App() {
  return (
    <div className="App min-h-screen bg-background text-foreground">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<RootRedirect />} />
            <Route path="/home" element={<Home />} />
            <Route path="/wizard" element={<ProjectWizard />} />
            <Route path="/projects" element={<Navigate to="/home" replace />} />
            <Route path="/single" element={<SingleUnitSelection />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/verify" element={<Verify />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
          </Routes>
        </BrowserRouter>
        <SessionExpiredModal />
      </AuthProvider>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
